import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';

import { fetchFreeComicFlashDeals } from 'Redux/ducks/algolia-calls';
import ItemList from 'Components/Product/Seo/ItemList';
import ProductCarousel from '../HomePage/ProductCarousel';

export default function FantasyVerseFreeComics() {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const doFetch = async () => {
      const newHits = await fetchFreeComicFlashDeals();
      setHits(newHits);
    };

    doFetch();
  }, []);

  const sliderSettings = {
    xs: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    sm: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    md: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    lg: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xl: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xxl: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  };

  if (isEmpty(hits)) return false;

  return (
    <section className="container">
      <div className="section-heading-container">
        <h2 className="section-title">
          <FormattedMessage
            id="fantasyverse-free-comics.heading.free-comic-book-day"
            defaultMessage="Free Comic Book Day"
          />
        </h2>
      </div>

      <ItemList title="Free Comic Book Day" hits={hits} />
      <ProductCarousel
        newCarousel
        leftAlign
        showFlashDealBar
        showFakeCards
        hitData={hits}
        carouselCoverSize="portrait"
        sliderSettings={sliderSettings}
      />
    </section>
  );
}
